<div class="app-container">
  <app-header></app-header>
  <div class="content-container">
    <app-sidenav></app-sidenav>
    <app-detail-view-wrapper>
      <div id="main-view">
        <router-outlet></router-outlet>
        @if (!isAdminRoute) {
          <app-homepage></app-homepage>
        }
      </div>
    </app-detail-view-wrapper>
    @if (!isAdminRoute) {
      <app-context-menu></app-context-menu>
    }
  </div>
  <app-footer></app-footer>
</div>
@if (!isAdminRoute) {
  <app-filter-drawer></app-filter-drawer>
}
